<template>
  <span class="status-pill" :style="{ background: meta.bg, color: meta.color }">
    <f7-icon :f7="meta.icon" size="12" />
    <span class="status-label">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import i18n from '../../js/i18n.js'
import { statusMeta } from '../../constants/payout-status.js'

const props = defineProps({ status: { type: String, required: true } })

const meta = computed(() => statusMeta(props.status))
const label = computed(() => i18n.global.t(`payout.status.${props.status}`))
</script>

<style scoped>
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
}
.status-label { max-width: 130px; overflow: hidden; text-overflow: ellipsis; }
</style>
